import { Item, ItemActions, ItemDescription, ItemHeader, ItemTitle, Switch } from '@ibsys/kit';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import type { BetaFeatureItem } from '@/entities/beta-feature';

/** Пропсы перечня бета-функций */
type Props = {
  /** Функции реестра в порядке, в котором их отдаёт бэкенд */
  features: BetaFeatureItem[];
  /** Код переключаемой сейчас функции; `null` — переключение не выполняется */
  pendingCode: string | null;
  /** Переключение состояния функции */
  onToggle: (code: string, isEnabled: boolean) => void;
};

/** Перечень бета-функций системы с переключателем состояния у каждой */
export const BetaFeaturesList: FC<Props> = ({ features, pendingCode, onToggle }) => {
  const { t } = useTranslation('betaFeatures');

  if (!features.length) {
    return <p className="text-sm text-muted-foreground">{t('empty')}</p>;
  }

  return (
    <div className="flex flex-col gap-3" data-testid="beta-features-list">
      {features.map((feature) => (
        <Item variant="outline" size="sm" key={feature.code} data-testid={`beta-feature-${feature.code}`}>
          <ItemHeader>
            <ItemTitle>{feature.name}</ItemTitle>
            <ItemActions className="ml-4">
              <Switch
                value={feature.isEnabled}
                onChange={(isEnabled) => onToggle(feature.code, isEnabled)}
                disabled={pendingCode === feature.code}
                aria-label={feature.name}
              />
            </ItemActions>
          </ItemHeader>
          {feature.description ? (
            <ItemDescription className="text-sm text-muted-foreground">{feature.description}</ItemDescription>
          ) : null}
        </Item>
      ))}
    </div>
  );
};
